import { useGetUserDataQuery } from '../store/user/user.api';
import { ADMIN_ROLE, MAINTAINER } from '../models/user.dto';

export const IS_ADMIN = () => {
   const { data: userData } = useGetUserDataQuery();
   return userData ? (userData.role === ADMIN_ROLE || userData.role === MAINTAINER) : false;
};